import React, { useEffect, useState } from "react";
import {
  Typography,
  Row,
  Col,
  Breadcrumb,
  Input,
  Collapse,
  Checkbox,
  Divider,
  Pagination,
  Select,
  Image,
} from "antd";
import { AppFooter } from "../LandingPage/Components/Footer/Footer";
import LogoGallery from "../LandingPage/Components/Logo/Logos";
import { useNotification } from "~/Hooks/useNotification";
import axios from "axios";
import type { MenuProps } from "antd";
import type { PaginationProps } from "antd";
import InvestImg from "@assets/KPMG/Invest.png";
import { PlusOutlined, MinusOutlined } from "@ant-design/icons";
import MainHeader from "../../Components/MainHeader/MainHeader";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { InvestmentHubData } from "./mock";
import { DocumentationCard } from "./DocumentationCard";
import DjuandaWater from "@assets/KPMG/assets/DjuandaWater.png";
import BinhDuong from "@assets/KPMG/assets/BinhDuong.png";
import plant from "@assets/KPMG/assets/plant.png";
import reserve from "@assets/KPMG/assets/reserve.png";
import { Icon } from "@iconify/react";
import { ProjectsCard } from "~/Components/ProjectsCard/ProjectsCard";
import { useMaskId } from "~/Hooks/useMaskId";
import { NoData } from "../InfratechMarketPlace/Components/NoData";

const { Panel } = Collapse;
export const StandardDocumentation: React.FC = () => {
  const { openToast } = useNotification();
  const [data, setData] = useState<any>([]);
  const [filteredData, setFilteredData] = useState<any>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(9);
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const [selectedAreas, setSelectedAreas] = useState<string[]>([]);
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const param = searchParams.get("q");
  const countryParam = searchParams.get("country");
  const sectorParam = searchParams.get("sector");
  const { unmask } = useMaskId();
  const sectorList: any = ["Utility", "Energy", "Built Environment"];
  const areaList: any = [
    "ASEAN",
    "Thailand",
    "Malaysia",
    "Indonesia",
    "Singapore",
    "Philippines",
    "Myanmar",
    "Vietnam",
    "Cambodia",
    "Laos",
    "Brunei Darussalam",
  ];

  //   useEffect(() => {
  //     // if (param?.toString()) {
  //     //   const category = unmask(param?.toString());
  //     //   handleCategoryChange(category);
  //     // }
  //   }, [param]);
  //   useEffect(() => {
  //     if (countryParam) {
  //       setSelectedAreas([countryParam]);
  //       updateFilterData([], [countryParam]);
  //     } else {
  //       setFilteredData(InvestmentHubData);
  //     }
  //   }, [countryParam]);

  //   useEffect(() => {
  //     if (sectorParam) {
  //       setSelectedCategories([sectorParam]);
  //       updateFilterData([sectorParam], []);
  //     } else {
  //       setFilteredData(InvestmentHubData);
  //     }
  //   }, [sectorParam]);

  useEffect(() => {
    getRecords();
  }, []);

  const handlePageChange = (page: number, pageSize?: number) => {
    setCurrentPage(page);
    setPageSize(pageSize || 9);
  };

  const getRecords = async () => {
    setData(InvestmentHubData);
    setFilteredData(InvestmentHubData);
  };

  const handleMenuClick: MenuProps["onClick"] = (e) => {
    console.log("click", e);
  };

  const updateSector = (sector: string) => {
    // let temp = [...selectedCategories];
    // if (temp.includes(sector)) {
    //   temp = temp.filter((cat) => cat !== sector);
    // } else {
    //   temp = [...temp, sector];
    // }
    // setSelectedCategories(temp);
    // updateFilterData(temp, selectedAreas);
  };

  const updateArea = (area: string) => {
    // let temp = [...selectedAreas];
    // if (temp.includes(area)) {
    //   temp = temp.filter((cat) => cat !== area);
    // } else {
    //   temp = [...temp, area];
    // }
    // setSelectedAreas(temp);
    // updateFilterData(selectedCategories, temp);
  };

  const updateFilterData = (sectors: any, areas: any) => {
    let tempData = [...InvestmentHubData];
    // if (sectors.length > 0) {
    //   tempData = tempData.filter((item: any) =>
    //     sectors.includes(item.categories[0].name)
    //   );
    // }
    // if (areas.length > 0) {
    //   if (!areas.includes("ASEAN")) {
    //     tempData = tempData.filter((item: any) =>
    //       areas.includes(item.Location)
    //     );
    //   }
    // }
    setFilteredData(tempData);
  };

  const items: MenuProps["items"] = [
    {
      label: "1st menu item",
      key: "1",
    },
    {
      label: "2nd menu item",
      key: "2",
    },
    {
      label: "3rd menu item",
      key: "3",
    },
    {
      label: "4rd menu item",
      key: "4",
    },
  ];

  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  const onSearch = (value: string) => {
    // let tempData = [...filteredData];
    // tempData = tempData.filter(
    //   (item) =>
    //     // item.categories[0].name.includes(value) ||
    //     // item.Location.includes(value) ||
    //     item.title && item.title.includes(value)
    //   // item.ProjectStage.includes(value) ||
    //   // item.TechInvolved.includes(value) ||
    //   // item.categories[0].subcategories[0].includes(value)
    // );
    // console.log("temp data", tempData, value);
    // setFilteredData(tempData);
  };

  const panelStyle = {
    marginBottom: 24,
    border: "none",
  };

  return (
    <>
      <MainHeader
        title={"STANDARD DOCUMENTATION FOR PROJECT AGREEMENTS"}
        imageSrc={InvestImg}
        text={
          "A hub to support and engage investors and infra owners/developers across sectors to access impact funds digitally. The decarb projects hub will offer investors access to project data and generate investible project names."
        }
      />
      <Row justify="center" style={{ backgroundColor: "#fff" }}>
        <Col lg={18} style={{ margin: "1.5rem 0 0 0" }} offset={2}>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Icon
                icon="ic:outline-home"
                height="20"
                onClick={() => navigate("/")}
                style={{
                  margin: "auto",
                  color: "#ef406a",
                  cursor: "pointer",
                }}
              />
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <a onClick={() => navigate("/standard-documentation")}>
                Standard Documentation for project agreements
              </a>
            </Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col lg={18} style={{ padding: "20px 0" }}>
          <Row gutter={16}>
            <Col lg={6}>
              <div className="listview-input">
                <Input
                  placeholder="Search"
                  style={{ width: "95%", borderRadius: "0.5rem" }}
                  onChange={(e) => {
                    onSearch(e.target.value);
                  }}
                />
                <div>
                  <Collapse
                    bordered={false}
                    defaultActiveKey={["area", "sector"]}
                    expandIcon={({ isActive }) =>
                      isActive ? <MinusOutlined /> : <PlusOutlined />
                    }
                    expandIconPosition="end"
                    style={{ background: "#fff" }}
                  >
                    <Panel header={"Sector"} key={"sector"}>
                      {sectorList.map((sector: any) => (
                        <div>
                          <Checkbox
                            checked={selectedCategories.includes(sector)}
                            onChange={() => updateSector(sector)}
                          >
                            {sector}
                          </Checkbox>
                        </div>
                      ))}
                    </Panel>
                    <Panel header={"Area"} key={"area"}>
                      {areaList.map((area: any) => (
                        <div>
                          <Checkbox
                            checked={selectedAreas.includes(area)}
                            onChange={() => updateArea(area)}
                          >
                            {area}
                          </Checkbox>
                        </div>
                      ))}
                    </Panel>
                  </Collapse>
                </div>
              </div>
            </Col>
            <Col lg={18}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Typography.Title level={4}>Projects</Typography.Title>
                {/* <Space className="invest-sort-button">
                  Sort By
                  <Dropdown menu={menuProps}>
                    <Button>
                      <Space>
                        Location &nbsp;&nbsp;
                        <DownOutlined />
                      </Space>
                    </Button>
                  </Dropdown>
                </Space> */}
              </div>
              {filteredData.length === 0 && (
                <Row gutter={[16, 16]} style={{ marginTop: 20 }}>
                  <Col span={24}>
                    <NoData />
                  </Col>
                </Row>
              )}
              {filteredData && filteredData.length > 0 && (
                <Row gutter={[32, 0]}>
                  {filteredData
                    .slice((currentPage - 1) * pageSize, currentPage * pageSize)
                    .map((data: any, i: number) => (
                      <Col lg={12} style={{ margin: "0.9rem 0" }}>
                        <DocumentationCard data={data} />
                      </Col>
                    ))}
                  <Col lg={24} className="invest-sort">
                    <Row justify="space-between">
                      <Col className="first-col"></Col>
                      <Col>
                        <Pagination
                          current={currentPage}
                          pageSize={pageSize}
                          total={filteredData.length}
                          onChange={handlePageChange}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
      <AppFooter />
    </>
  );
};
